document.addEventListener('DOMContentLoaded', function () {
	const VerticalMenu = {
		menuJson: null,
		assetsUrl: null,

		init: function () {			
			this.loadAssetsUrl();
			this.loadMenuFromMetaobject(() => {
				this.setEvents();
			});
		},

		loadAssetsUrl: function () {
			const overlay = document.querySelector('.vertical-menu-overlay');
			if (!overlay) return;

			this.assetsUrl = overlay.getAttribute('data-assets-url') || '';
			if (this.assetsUrl) {
				this.assetsUrl = this.assetsUrl.substring(0, this.assetsUrl.lastIndexOf('/')) + '/';
			}
		},

		/**
		 * Carga el JSON del menú desde el metaobjeto vertical_menu / vertical-menu-q9lhzod2
		 */
		loadMenuFromMetaobject: async function (callback) {
			const client = this.getStorefrontApiClient();
			const query = this.getMetaobjectGraphqlQuery();			

			try {
				const data = await client.request(query);				

				if (!data?.data?.metaobject) {
					console.warn('Vertical menu: metaobject not found');
					return;
				}

				// Campo del metaobjeto que contiene el JSON -> key = "menu"
				const menuField = data.data.metaobject.fields.find(field => field.key === 'menu');

				if (!menuField || !menuField.value) {
					console.warn('Vertical menu: menu field not found or empty in metaobject');
					return;
				}

				const rawMenuJson = JSON.parse(menuField.value);
				
				this.transformMenuJson(rawMenuJson);				
				this.updateWindowGlobal();

				if (typeof callback === 'function') {
					callback();
				}
			} catch (error) {
				console.error('Vertical menu:', error);
				throw Error('Vertical menu: ' + error);
			}
		},

		getStorefrontApiClient: function () {
			if (typeof ShopifyStorefrontAPIClient !== 'undefined') {
				return ShopifyStorefrontAPIClient.createStorefrontApiClient({
					storeDomain: 'farmaciasdirect-eu.myshopify.com',
					apiVersion: '2025-10',
					publicAccessToken: '8084a6622e40fb7f6caa45eec5f0e699'
				});
			} else {
				throw Error('Vertical menu: ShopifyStorefrontAPIClient is not defined!');
			}
		},

		/**
		 * Query GraphQL al metaobjeto vertical_menu / vertical-menu-q9lhzod2
		 */
		getMetaobjectGraphqlQuery: function () {
			return `
				query VerticalMenu @inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
					metaobject(handle: { type: "vertical_menu", handle: "vertical-menu-q9lhzod2" }) {
						id
						handle
						type
						fields {
							key
							value
						}
					}
				}
			`;
		},

		transformMenuJson: function (rawMenuJson) {
			this.menuJson = {};

			for (const value of Object.values(rawMenuJson)) {
				if (!(value.id in this.menuJson)) {
					this.menuJson[value.id] = [];
				}
				this.iterateChildren(value);
			}
		},

		iterateChildren: function (item) {
			if (item.children && item.children.length > 0) {
				if (!(item.id in this.menuJson)) {
					this.menuJson[item.id] = [];
				}

				for (const child of Object.values(item.children)) {
					this.menuJson[item.id].push({
						code: child.code,
						handle: child.handle,
						id: child.id,
						level: child.level,
						name: child.name
					});

					this.iterateChildren(child);
				}
			}
		},

		updateWindowGlobal: function () {			
			window.menuJson = this.menuJson;
		},

		setEvents: function () {
			const overlay = document.querySelector('.vertical-menu-overlay');
			if (!overlay) return;

			// Abrir menú vertical
			document
				.querySelectorAll('.vertical-menu > .list-menu__link')
				.forEach(link => {
					link.addEventListener('click', function () {
						this.closest('.list-menu__item')?.classList.add('active');
						overlay.classList.add('active');
					});
				});

			// Botones "next"
			document
				.querySelectorAll('.vertical-menu .next-button')
				.forEach(button => {
					button.addEventListener('click', () => {
						this.buildSubmenuIfNotExists(button);
						this.removeActiveSiblings(button);
						button.closest('.list-submenu__item')?.classList.add('active');
					});
				});

			// Botones "back" existentes en el DOM
			document
				.querySelectorAll('.vertical-menu .back-button')
				.forEach(button => {
					button.addEventListener('click', function () {
						const item = this.closest('.header__submenu')?.closest('.list-submenu__item');
						item?.classList.remove('active');
					});
				});

			// Click fuera del menú → cerrar
			document.addEventListener('click', function (e) {
				if (!e.target.closest('.vertical-menu')) {
					document
						.querySelectorAll('.vertical-menu.list-menu__item, .vertical-menu .list-submenu__item')
						.forEach(item => item.classList.remove('active'));
					overlay.classList.remove('active');
				}
			});

			// Hover en otros menús con hijos → cerrar vertical
			document
				.querySelectorAll('.list-menu__link.with-children')
				.forEach(link => {
					link.addEventListener('mouseenter', function () {
						document
							.querySelectorAll('.vertical-menu.list-menu__item, .vertical-menu .list-submenu__item')
							.forEach(item => item.classList.remove('active'));
						overlay.classList.remove('active');
					});
				});
		},

		removeActiveSiblings: function (button) {
			const parentSubmenu = button.closest('.header__submenu');
			if (!parentSubmenu) return;

			parentSubmenu
				.querySelectorAll('.list-submenu__item')
				.forEach(sibling => sibling.classList.remove('active'));
		},

		buildSubmenuIfNotExists: function (parentButton) {			
			const parentId = parentButton.getAttribute('data-id');
			const parentName = parentButton.getAttribute('data-name');
			const parentHandle = parentButton.getAttribute('data-handle');
			const parentLevel = parseInt(parentButton.getAttribute('data-level'), 10);

			if (!parentId || !(parentId in this.menuJson)) return;
			if (document.getElementById('submenu_' + parentId)) return;

			const submenu = this.menuJson[parentId];

			const ul = document.createElement('ul');
			ul.classList.add(
				'header__submenu',
				`header__submenu--level${parentLevel + 1}`,
				'gradient',
				'motion-reduce'
			);
			ul.id = 'submenu_' + parentId;

			const div = document.createElement('div');
			div.classList.add('header__submenu--overflow');

			// Bloque back
			const li = document.createElement('li');
			li.classList.add('list-submenu__item', 'link-back');

			const backButton = document.createElement('button');
			backButton.classList.add('back-button');

			const img = document.createElement('img');
			img.src = this.assetsUrl + 'vertical_menu_icon_back.svg';

			const a = document.createElement('a');
			a.classList.add('list-submenu__link');
			a.href = '/collections/' + parentHandle;
			a.innerHTML = parentName;

			backButton.addEventListener('click', function () {
				const item = this.closest('.header__submenu')?.closest('.list-submenu__item');
				item?.classList.remove('active');
			});

			backButton.appendChild(img);
			li.appendChild(backButton);
			li.appendChild(a);
			div.appendChild(li);
			ul.appendChild(div);

			// Hijos
			submenu.forEach(child => {
				const liChild = document.createElement('li');
				liChild.classList.add('list-submenu__item');

				const aChild = document.createElement('a');
				aChild.classList.add('list-submenu__link');
				aChild.href = '/collections/' + child.handle;
				aChild.innerHTML = child.name;

				liChild.appendChild(aChild);

				if (child.id in this.menuJson) {
					const buttonChild = document.createElement('button');
					buttonChild.classList.add('next-button');
					buttonChild.setAttribute('data-id', child.id);
					buttonChild.setAttribute('data-name', child.name);
					buttonChild.setAttribute('data-handle', child.handle);
					buttonChild.setAttribute('data-level', parentLevel + 1);

					const imgChild = document.createElement('img');
					imgChild.src = this.assetsUrl + 'vertical_menu_icon_open_submenu.svg';

					buttonChild.addEventListener('click', () => {
						this.buildSubmenuIfNotExists(buttonChild);
						this.removeActiveSiblings(buttonChild);
						buttonChild.closest('.list-submenu__item')?.classList.add('active');
					});

					buttonChild.appendChild(imgChild);
					liChild.appendChild(buttonChild);
				}

				div.appendChild(liChild);
			});

			parentButton.after(ul);
		}
	};

	VerticalMenu.init();
});